import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import AddRewardContainer from '../addRewardContainer/AddRewardContainer';
import EditRewardContainer from '../editRewardContainer/EditRewardContainer';
import { RewardList as RewardListContainer } from "../../../RnRCommonComponent";
import CoreBadge from '../../../RnRCommonComponent/CoreBadge/CoreBadge';
import {
	BADGE_TYPE,
	REVERSE_MAPING_BADGE_TYPE,
	ICON_COMPLETE_MAP
} from '../../../RnRCommonComponent/CoreBadge/rewardsConstants.js'
import '../manageRewardContainer/manageReward.scss'
import Automated from '../../../assets/svg/automated.svg'
import NoDataState from '../../../RnRCommonComponent/noDataState/NoDataState.jsx';
import { withApollo } from 'react-apollo';
import { gql } from 'graphql-tag';

const ManageRewardContainer = ({ currentUser, client }) => {
	const QUERY_BADGES_BY_COMPANY_ID = gql`query QueryBadgesByCompanyIdIndex($companyId: ID!, $limit: Int, $nextToken: String) {
		queryBadgesByCompanyIdIndex(companyId: $companyId, limit: $limit, nextToken: $nextToken) {
			items {
				id
				companyId
				badgeTypeId
				assignmentSSORequiredId
				recipientPayTypeId
				recipientSSORequiredId
				physicalAwardActivityId
				iconId
				snappyGrantId
				snappyGrant {
					id
					snappyCampaignId
					name
					description
					costInCurrency
				}
				name
				label
				description
				image
				color
				gradientColor
				points
				bonusPoints
				rewardBonus
				rewardMaxBonus
				assignmentLimit
				assignmentLevelId
				recipientLevelId
				isPreApproved
				isRewardRequiresDate
				visibility
				isAssignmentSSORequired
				isRecipientSSORequired
				automationRule
				externalWorkFlowId
			}
			nextToken
		}
	}`

	const GET_BADGE_BY_ID = gql`query GetBadgeById($companyId: ID!, $id: ID!) {
	 getBadgeById(
	   companyId: $companyId
	   id: $id
	 ) {
	   assignmentLevelId
	   assignmentLimit
	   assignmentSSORequiredId
	   automationRule
	   badgeTypeId
	   bonusPoints
	   color
	   createdAt
	   companyId
	   createdBy
	   deletedBy
	   deletedAt
	   description
	   gradientColor
	   externalWorkFlowId
	   image
	   iconId
	   id
	   isPreApproved
	   isAssignmentSSORequired
	   isRewardRequiresDate
	   isRecipientSSORequired
	   label
	   points
	   name
	   physicalAwardActivityId
	   recipientLevelId
	   recipientPayTypeId
	   recipientSSORequiredId
	   rewardBonus
	   rewardMaxBonus
	   snappyGrant {
	     snappyCampaign {
	       name
	       companyId
	       id
	     }
	     snappyCampaignTierId
	     snappyCampaignId
	     pointsRequired
	     snappyCampaignId
	     description
	     name
	     costInCurrency
	   }
	   snappyGrantId

	   updatedAt
	   updatedBy
	   visibility
	 }
}`


	const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	const [isEditModalOpen, setIsEditModalOpen] = useState(false)
	const [selectedBadge, setSelectedBadge] = useState();
	const [detailedBadge, setDetailedBadge] = useState(null);
	const [shouldRefresh, setShouldRefresh] = useState(false);
	const [badges, setBadges] = useState({
		peerToPeer: [],
		nominated: [],
		automated: []
	});
	const [isLoading, setIsLoading] = useState(true);
	const [isLoadingBadgeDetails, setIsLoadingBadgeDetails] = useState(false);

	useEffect(() => {
		const fetchBadgesByCompany = async () => {
			if (client && currentUser?.companyId) {
				try {
					setIsLoading(true);
					const { data, error } = await client.query({
						query: QUERY_BADGES_BY_COMPANY_ID,
						variables: {
							companyId: currentUser.companyId,
							limit: 100,
							nextToken: null
						},
						fetchPolicy: 'network-only'
					});
					if (error) {
						console.error('Error fetching badges by company ID:', error);
						return;
					}
					
					if (data?.queryBadgesByCompanyIdIndex?.items) {

						
						const enrichedBadges = data.queryBadgesByCompanyIdIndex.items.map(badge => {
							const badgeType = REVERSE_MAPING_BADGE_TYPE[badge.badgeTypeId] || '';
							
							let iconInfo = null;
							if (badge.iconId) {
				iconInfo = ICON_COMPLETE_MAP.find(icon => icon.id === badge.iconId);
							}
							
							return {
								...badge,
								badgeType,
								iconInfo
							};
						});
						
						const peerToPeer = enrichedBadges.filter(badge =>
							badge.badgeType === 'PEERTOPEER'
						);
						
						const nominated = enrichedBadges.filter(badge =>
							badge.badgeType === 'NOMINATED'
						);
						
						const automated = enrichedBadges.filter(badge =>
							badge.badgeType === 'AUTOMATED'
						);
						
						setBadges({
							peerToPeer,
							nominated,
							automated
						});
					}
				} catch (error) {
					console.error('Exception when fetching badges by company ID:', error);
				} finally {
					setIsLoading(false);
				}
			}
		};
		
		fetchBadgesByCompany();
	}, [client, currentUser]);

	const showAddModal = () => {
		setIsAddModalOpen(true);
	};

	const handleCloseAddModal = () => {
		setIsAddModalOpen(false);
	};

	const handleIconClickEvent = async (badge) => {
		setSelectedBadge(badge);
		
		try {
			setIsLoadingBadgeDetails(true);
			
			const { data, error } = await client.query({
				query: GET_BADGE_BY_ID,
				variables: {
					companyId: currentUser.companyId,
					id: badge.id
				},
				fetchPolicy: 'network-only'
			});
			
			if (error) {
				console.error('Error fetching badge details:', error);
			}
			
			if (data?.getBadgeById) {	
				const badgeType = REVERSE_MAPING_BADGE_TYPE[data.getBadgeById.badgeTypeId] || '';
				let iconInfo = null;
				
				if (data.getBadgeById.iconId) {
					iconInfo = ICON_COMPLETE_MAP.find(icon => icon.id === data.getBadgeById.iconId);
				}
				
				const enrichedDetailedBadge = {
					...data.getBadgeById,
					badgeType,
					iconInfo,
					snappyGrantId: data.getBadgeById.snappyGrantId || null
				};
				
				setDetailedBadge(enrichedDetailedBadge);
			}
		} catch (error) {
			console.error('Exception when fetching badge details:', error);
		} finally {
			setIsLoadingBadgeDetails(false);
			setIsEditModalOpen(true);
		}
	}

	return (
		<>
			<div className="main">
				<div className="page-title">
					<h2 className="page-heading-manage-reward">Manage Recognitions</h2>
					<div style={{ display: "flex" }}>
						<Button type="link" className="add-btn btn-lg create-reward" onClick={showAddModal}>
							<span className="icon-circle">
								<b className="icon-plus" />
							</span>
							<span>Create Recognition</span>
						</Button>
					</div>
				</div>
			</div>
			{isAddModalOpen && <AddRewardContainer
				isModalOpen={isAddModalOpen}
				handleCloseModal={handleCloseAddModal}
				setShouldRefresh={setShouldRefresh}
				currentUser={currentUser}
			/>}

			{isEditModalOpen && <EditRewardContainer
				isEditModalOpen={isEditModalOpen}
				handleCloseModal={() => {
					setIsEditModalOpen(false);
					setDetailedBadge(null);
				}}
				selectedBadge={detailedBadge || selectedBadge}
				isLoading={isLoadingBadgeDetails}
				setShouldRefresh={setShouldRefresh}
				currentUser={currentUser}
			/>}

			<div className="row">
				<div className="col-12">
					{isLoading ? (
						<div className="loading-container">Loading badges...</div>
					) : (
						<>
							<RewardListContainer
								client={client}
								currentUser={currentUser || {}}
								handleIconClickEvent={handleIconClickEvent}
								title="On-The-Spot Recognitions"
								badgeType={BADGE_TYPE.PEERTOPEER}
								shouldRefresh={shouldRefresh}
								setShouldRefresh={setShouldRefresh}
								isDetailsShown={true}
								isPointsShown={false}
								isIssuedVisible={true}
								badges={badges.peerToPeer.map(badge => {
									const hasSnappyId = !!badge.snappyGrantId;
									const currencySymbol = badge?.snappyGrant?.currencySymbol || '$';
									const isManagerOrAdmin = ['manager', 'admin', 'superAdmin', 'supportAdmin'].includes(currentUser?.role?.toLowerCase());
									
									const snappyDetails = hasSnappyId ? {
										id: badge.snappyGrantId,
										name: badge.snappyGrant?.name || 'Snappy Reward',
										costInCurrency: `${currencySymbol}${badge.snappyGrant?.costInCurrency || 0}`
									} : {};
									
									return {
										...badge,
										hideSnappyIcon: !(hasSnappyId && isManagerOrAdmin),
										snappyDetails
									};
								})}
								useCustomData={true}
							/>
							<RewardListContainer
								client={client}
								currentUser={currentUser || {}}
								handleIconClickEvent={handleIconClickEvent}
								title="Milestones"
								badgeType={BADGE_TYPE.AUTOMATED}
								shouldRefresh={shouldRefresh}
								setShouldRefresh={setShouldRefresh}
								isDetailsShown={true}
								isPointsShown={false}
								isIssuedVisible={true}
								badges={badges.automated.map(badge => {
									const hasSnappyId = !!badge.snappyGrantId;
									const isManagerOrAdmin = ['manager', 'admin', 'superAdmin', 'supportAdmin'].includes(currentUser?.role?.toLowerCase());
									
									const snappyDetails = hasSnappyId ? {
										id: badge.snappyGrantId,
										name: badge.snappyGrant?.name || 'Snappy Reward',
										costInCurrency: `${badge?.snappyGrant?.currencySymbol || '$'}${badge.snappyGrant?.costInCurrency || 0}`
									} : {};
									
									return {
										...badge,
										hideSnappyIcon: !(hasSnappyId && isManagerOrAdmin),
										snappyDetails
									};
								})}
								useCustomData={true}
							/>
							<RewardListContainer
								client={client}
								currentUser={currentUser || {}}
								handleIconClickEvent={handleIconClickEvent}
								title="Nominations"
								badgeType={BADGE_TYPE.NOMINATED}
								shouldRefresh={shouldRefresh}
								setShouldRefresh={setShouldRefresh}
								isDetailsShown={true}
								isPointsShown={false}
								isIssuedVisible={true}
								badges={badges.nominated.map(badge => {
									const hasSnappyId = !!badge.snappyGrantId;
									const isManagerOrAdmin = ['manager', 'admin', 'superAdmin', 'supportAdmin'].includes(currentUser?.role?.toLowerCase());
									
									const snappyDetails = hasSnappyId ? {
										id: badge.snappyGrantId,
										name: badge.snappyGrant?.name || 'Snappy Reward',
										costInCurrency: `$${badge.snappyGrant?.costInCurrency || 0}`
									} : {};
									
									return {
										...badge,
										hideSnappyIcon: !(hasSnappyId && isManagerOrAdmin),
										snappyDetails
									};
								})}
								useCustomData={true}
							/>
						</>
					)}
					{!isLoading && (
						<div className="d-card ">
							<div className="d-card-head">
								<h4 className="d-title-no-case">{"Automated Recognitions"}</h4>
							</div>
							<div style={{
								maxHeight: "220px",
								height: "100%",
								overflow: "unset",
							}}>
								<div className="badges-list-flex">
									{badges.automated.length === 0 ? (
										<NoDataState title={"No automated recognitions generated yet."} />
									) : (
										badges.automated.map(badge => {
											const hasSnappyId = !!badge.snappyGrantId;
											const isManagerOrAdmin = ['manager', 'admin', 'superAdmin', 'supportAdmin'].includes(currentUser?.role?.toLowerCase());
											
											const snappyDetails = hasSnappyId ? {
												id: badge.snappyGrantId,
												name: badge.snappyGrant?.name || 'Snappy Reward',
												costInCurrency: `$${badge.snappyGrant?.costInCurrency || 0}`
											} : {};
											
											const hideSnappyIcon = !(hasSnappyId && isManagerOrAdmin);
											
											return (
												<div
													key={badge.id}
													className='badges-container'
													style={{ opacity: 1 }}>
													<div
														className='badges-container-edit-target'
														style={{ cursor: 'pointer' }}
														onClick={() => handleIconClickEvent(badge)}
													>
														<div className="badges-img">
															{badge.iconInfo ? (
																<div className='badges-svg'>
																	<CoreBadge
																		badgeType={badge.badgeType}
																		badgeIcon={badge.iconInfo.icon || "AWARD"}
																		label={badge.name || "Badge"}
																		color={badge.color || "#6366f1"}
																		gradientColor={badge.gradientColor || "#10b981"}
																		hideSnappyIcon={hideSnappyIcon}
																		snappyDetails={snappyDetails}
																	/>
																</div>
															) : (
																<div className='badges-svg'>
																	<img src={Automated} alt='Badge' />
																</div>
															)}
														<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
															<div style={{ marginBottom: "-0.5rem" }}>{badge.issuedCount || 0}</div>
															<div>Issued</div>
														</div>
													</div>
												</div>
												<div style={{
													display: "flex",
													justifyContent: "center",
													marginTop: "2px"
												}}>
													<Button
														type='link'
														className="text-center img-label"
														onClick={() => handleIconClickEvent(badge)}
													>
														Details
													</Button>
												</div>
											</div>
										)})
									)}
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default withApollo(ManageRewardContainer);
